// Helper for enforcing the dtae time format.
import { format } from "date-fns";

export function formatDateTime(value) {
  if (!value) return "-";
  try {
    return format(new Date(value), "dd MMM yyyy, hh:mm a");
  } catch (err) {
    console.warn("Invalid date:", value);
    return "-";
  }
}